import { AccountCircle, EmailAt, People, TextBlock, TextFields, Tickets, Time } from "@livechat/design-system-icons";
import { DesignToken, Icon, SpacingToken, Text } from "@livechat/design-system-react-components";

import Flex from "components/layout/Flex";
import { RichTextVariables } from "components/rich-editor/plugins/constants";
import { withVar } from "themes/helpers";

import { ContentType, VARIABLE_ICON_CUSTOM_COLOR } from "../constants";

export const ticketHistoryStub = `{{#events}}
    <hr />
    <div>
      <em>On {{date.ownerUS}} {{#author.isRule}}agent{{/author.isRule}}{{#author.isClient}}{{author.email}}{{/author.isClient}}{{#author.isAgent}}{{#author.name}}{{.}}{{/author.name}}{{^author.name}}{{author.email}}{{/author.name}}{{/author.isAgent}} wrote:</em>
      <br /><br />
      {{message.text}}
      {{#attachments.0}}
      <br />
      <em>Attachments:</em>
      <ul>
        {{#attachments}}
        <li><a href="{{url}}">{{name}}</a></li>
        {{/attachments}}
      </ul>
      {{/attachments.0}}
    </div>
{{/events}}`;

export const peopleInTheLoopStub = `{{#ticket.cc.0}}
{{#ticket.cc}} <a href="mailto:{{email}}">{{email}}</a> {{/ticket.cc}}
<br />
{{/ticket.cc.0}}{{^ticket.cc.0}}–{{/ticket.cc.0}}`;

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const pickerItems = (contentType: ContentType, insertCleanVariables?: boolean) => [
  {
    key: RichTextVariables.Message,
    props: {
      name: (
        <p className="menu-item">
          <Flex gap={withVar(SpacingToken.Spacing2)}>
            <Icon source={TextBlock} customColor={VARIABLE_ICON_CUSTOM_COLOR} />
            <Text>Message&nbsp;</Text>
            <Text customColor={withVar(DesignToken.ContentBasicSecondary)}>(required)</Text>
          </Flex>
        </p>
      ),
      value: contentType === ContentType.HTML ? "{{{message.html}}}" : "{{message.text}}",
    },
  },
  {
    key: RichTextVariables.RequesterName,
    props: {
      name: (
        <p className="menu-item">
          <Flex gap={withVar(SpacingToken.Spacing2)}>
            <Icon source={AccountCircle} customColor={VARIABLE_ICON_CUSTOM_COLOR} />
            <Text>Requester name</Text>
          </Flex>
        </p>
      ),
      value: "{{ticket.requesterName}}",
    },
  },
  {
    key: RichTextVariables.RequesterEmail,
    props: {
      name: (
        <p className="menu-item">
          <Flex gap={withVar(SpacingToken.Spacing2)}>
            <Icon source={EmailAt} customColor={VARIABLE_ICON_CUSTOM_COLOR} />
            <Text>Requester email</Text>
          </Flex>
        </p>
      ),
      value: "{{ticket.requesterEmail}}",
    },
  },
  {
    key: RichTextVariables.ShortID,
    props: {
      name: (
        <p className="menu-item">
          <Flex gap={withVar(SpacingToken.Spacing2)}>
            <Icon source={Tickets} customColor={VARIABLE_ICON_CUSTOM_COLOR} />
            <Text>Ticket Short ID</Text>
          </Flex>
        </p>
      ),
      value: "{{ticket.shortID}}",
    },
  },
  {
    key: RichTextVariables.AgentName,
    props: {
      name: (
        <p className="menu-item">
          <Flex gap={withVar(SpacingToken.Spacing2)}>
            <Icon source={AccountCircle} customColor={VARIABLE_ICON_CUSTOM_COLOR} />
            <Text>Agent name</Text>
          </Flex>
        </p>
      ),
      value: insertCleanVariables
        ? "{{ticket.agentName}}"
        : "{{#ticket.agentName}}{{ticket.agentName}}{{/ticket.agentName}}{{^ticket.agentName}}–{{/ticket.agentName}}",
    },
  },
  {
    key: RichTextVariables.AgentEmail,
    props: {
      name: (
        <p className="menu-item">
          <Flex gap={withVar(SpacingToken.Spacing2)}>
            <Icon source={EmailAt} customColor={VARIABLE_ICON_CUSTOM_COLOR} />
            <Text>Agent email</Text>
          </Flex>
        </p>
      ),
      value: "{{ticket.agentEmail}}",
    },
  },
  {
    key: RichTextVariables.Subject,
    props: {
      name: (
        <p className="menu-item">
          <Flex gap={withVar(SpacingToken.Spacing2)}>
            <Icon source={TextFields} customColor={VARIABLE_ICON_CUSTOM_COLOR} />
            <Text>Subject</Text>
          </Flex>
        </p>
      ),
      value: "{{ticket.subject}}",
    },
  },
  {
    key: RichTextVariables.TicketHistory,
    props: {
      name: (
        <p className="menu-item">
          <Flex gap={withVar(SpacingToken.Spacing2)}>
            <Icon source={Time} customColor={VARIABLE_ICON_CUSTOM_COLOR} />
            <Text>Ticket history</Text>
          </Flex>
        </p>
      ),
      value: ticketHistoryStub,
    },
  },
  {
    key: RichTextVariables.PeopleInTheLoop,
    props: {
      name: (
        <p className="menu-item">
          <Flex gap={withVar(SpacingToken.Spacing2)}>
            <Icon source={People} customColor={VARIABLE_ICON_CUSTOM_COLOR} />
            <Text>People in the loop</Text>
          </Flex>
        </p>
      ),
      value: peopleInTheLoopStub,
    },
  },
];
